import { SURVEYS_ANSWERS_LOCAL_STORAGE_KEY } from "../../../domain/survey/survey.constants";

class LocalStorageSurvey {
  static getAnswers() {
    return localStorage.getItem(SURVEYS_ANSWERS_LOCAL_STORAGE_KEY);
  }

  static setAnswers(newSurveyAnswers: {
    [key: string]: {
      [key: string]: string[];
    };
  }) {
    localStorage.setItem(
      SURVEYS_ANSWERS_LOCAL_STORAGE_KEY,
      JSON.stringify(newSurveyAnswers),
    );
  }
}

export default LocalStorageSurvey;
